
import {
  defineComponent,
  onMounted,
  computed,
  ref,
  watchEffect,
  watch,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import objectPath from "object-path";
import InvestmentOpportunities from "@/views/crafted/pages/investment-opportunities.vue";

export default defineComponent({
  name: "find-investment-opportunities",
  components: {
    InvestmentOpportunities,
  },
  setup() {
    const loading = ref<boolean>(false);
    const globalSearch = ref<boolean>(false);
    watch(globalSearch, (value) => {
      if (value) {
        selectedIndustrySectors.value = industrySectors.value?.map(
          (is) => is.id
        );
      }
    });
    const store = useStore();
    const user = computed(() => store.getters.getUser);
    const founderRequisiteExperts = ref<Array<Record<string, unknown>>>([]);
    watchEffect(() => {
      founderRequisiteExperts.value = user.value.founderRequisiteExpert;
    });
    const isAlreadyConnected = (id) => {
      return founderRequisiteExperts.value.some((expert) => {
        return objectPath.get(expert, "id", false) == id;
      });
    };
    const industrySectors = computed(() => store.getters.industrySectorsGetter);
    const selectedIndustrySectors = ref<Array<number>>([]);
    const filteredInvestmentOpportunities = computed(
      () => store.getters.getFilteredInvestmentOpportunities
    );
    const filteredExperts = computed(() => store.getters.filteredExpertsGetter);
    const showError = ref<boolean>(false);
    const addToIndustrySectors = (event) => {
      showError.value = false;
      if (event.target.checked) {
        selectedIndustrySectors.value = [
          ...selectedIndustrySectors.value,
          event.target.dataset["id"],
        ];
      } else {
        selectedIndustrySectors.value = selectedIndustrySectors.value.filter(
          (i) => {
            return i != event.target.dataset["id"];
          }
        );
      }
    };
    const findOpportunityInvestment = async () => {
      loading.value = true;
      try {
        const response = await store.dispatch(
          Actions.FIND_INVESTMENT_OPPORTUNITIES,
          selectedIndustrySectors.value.length
            ? {
                industrySectorIds: selectedIndustrySectors.value,
              }
            : null
        );
        if (response !== true) throw new Error();
        loading.value = false;
      } catch (err) {
        loading.value = false;
      }
    };
    onMounted(async () => {
      setCurrentPageBreadcrumbs("Find Investment Opportunities", []);
      if (!industrySectors.value.length)
        await store.dispatch(Actions.GET_INDUSTRY_SECTORS);
    });

    return {
      loading,
      globalSearch,
      showError,
      industrySectors,
      addToIndustrySectors,
      filteredExperts,
      isAlreadyConnected,
      filteredInvestmentOpportunities,
      findOpportunityInvestment,
      selectedIndustrySectors,
    };
  },
});
